// src/pages/Users/ChangePasswordModal.jsx
import React, { useState } from 'react';
import { toast } from 'react-toastify';

const ChangePasswordModal = ({ show, onClose, onSubmit, user }) => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!newPassword || !confirmPassword) {
      toast.error('Please enter password');
      return;
    }
    
    if (newPassword !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }
    
    if (newPassword.length < 6) {
      toast.error('Password must be at least 6 characters');
      return;
    }
    
    setLoading(true);
    try {
      await onSubmit(user._id, newPassword);
      setNewPassword('');
      setConfirmPassword('');
      onClose();
    } catch (error) {
      // Error handled in parent
    } finally {
      setLoading(false);
    }
  };

  if (!show || !user) return null;

  return (
    <div className="modal fade admin-modal-one show" style={{ display: 'block', background: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title">Change Password</h1>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="row g-3">
                <div className="col-12">
                  <h2 className="changeps-username">{user.username}</h2>
                </div>
                <div className="col-12">
                  <label className="modal-label">New Password</label>
                  <input
                    type="password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    className="form-control modal-input"
                    placeholder="Enter new password"
                    required
                  />
                </div>
                <div className="col-12">
                  <label className="modal-label">Confirm Password</label>
                  <input
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className="form-control modal-input"
                    placeholder="Confirm new password"
                    required
                  />
                </div>
                <div className="col-12">
                  <button type="submit" className="addnew-user" disabled={loading}>
                    {loading ? 'Saving...' : 'Save'}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordModal;